import { ObjectRegistry } from '@lts-web/registry';
import FormData, { validators } from '@lts-web/data-objects/FormData';
import SearchModuleUtil from '@lts-web/utils/SearchModuleUtil';
import * as dataSets from '@lts-web/schemas/formDataSets';

class SyncFormUtil {
    static #registry = new ObjectRegistry(FormData);

    static findFormData (moduleName) {
        if (typeof moduleName === 'string')
            return SyncFormUtil.getFormData(moduleName);

        return SyncFormUtil.getCurrentFormData();
    }

    static createFormData (data) {
        if (typeof data !== 'object')
            throw new TypeError(`First argument must be of type 'object'`);

        const { moduleName } = data;

        if (SyncFormUtil.hasFormData(moduleName)){
            console.error(`The FormData of '${moduleName}' already exists`);
            return;
        }

        return SyncFormUtil.#registry.set(moduleName, new FormData(data));
    }

    static getCurrentFormData () {
        return SyncFormUtil.getFormData(SearchModuleUtil.getCurrentModuleName())
    }

    static getFormData (moduleName) {
        const formData = SyncFormUtil.#registry.get(moduleName);

        if (!formData) {
            console.error(`FormData of ${moduleName} is not registered, please check createForm exists`);
        }

        return formData;
    }

    static hasFormData (moduleName) {
        return SyncFormUtil.#registry.has(moduleName);
    }

    static getDataKeys (dataSetName) {
        return Object.keys(SyncFormUtil.useDataSet(dataSetName));
    }

    static useDataSet (dataSetName, ...values) {
        return dataSets[dataSetName].apply(null, values);
    }

    static validate (dataSetName, ...values) {
        return validators[dataSetName].apply(null, values);
    }

    static buildSearchURL (url, formElement) {
        const withoutEmpties = $(formElement).serialize().replace(/[^&]+=\.?(?:&|$)/g, '');
        const emptyParams = $(formElement).serialize().match(/[^&]+=\.?(?:&|$)/g);
        const emptyParamsUrl = emptyParams != null ? emptyParams.join().replace(/&,/g, '&') : '';

        return url + "?makeRedirect=false&" + withoutEmpties + "&" +  emptyParamsUrl;
    }
}

export default SyncFormUtil;